import { createContext, useContext, useState } from 'react'
import { TestDataManagement } from './test/TestDataManagemnt'

const AppStateContext = createContext();

export const useAppStateContext = () => {
  return useContext(AppStateContext);
};

export const AppStateProvider = ({children}) => {

  const tenantList = TestDataManagement.listTenantData();
  const userList = TestDataManagement.listUserData("user");
  const systemUserList = TestDataManagement.listUserData("admin");
  const productUserList = TestDataManagement.listUserData("product");

  const [value,setValue] = useState({
    top:[],
  });
  const appState = {
    value,
    setValue
  };

  return <AppStateContext.Provider value={appState}>{children}</AppStateContext.Provider>

};